/**
 * @legacy
 * @extends base_common.html template
 */
import '../../ui/legacy/common'

/**
 * @legacy
 * @prev translate/templates/translate/base.html
 */
import 'select2/select2.css'

import '../../ui/legacy/css/template_style_desktop.css'
import '../../ui/legacy/css/template_style_responsive.css'
import '../../ui/legacy/css/select2.css'

import './css/translate.css'

import 'select2/select2'
import '../../ui/legacy/js/scrollheader'

$(document).ready(function() {
    /* Apply Select2 on select boxes */
    $('select:not(#change-object, .noselect2)').removeClass('form-control').select2({
        minimumResultsForSearch: 5
    });
});

document.addEventListener('DOMContentLoaded', async () => {
  const flags = JSON.parse(document.body.dataset.flags)
  /**
   * @legacy
   * @prev templates/administration/base.html#script(src=reseller.js)
   */
  flags.isEntryList && await import('./js/scroll-list.js')
})
